// タブ切り替え
const tab = () => {
    const elList = document.querySelectorAll('.js_tab');
    if (!elList.length) return;

    elList.forEach(el => {
        const triggerList = el.querySelectorAll('.js_tab_trigger');
        const targetList = el.querySelectorAll('.js_tab_target');

        /**
         * トリガー要素がクリックされた時に呼ばれる関数
         * 
         * @var {number} nth クリックされた要素の番号
        */
        const changeActive = (nth) => {
            // 一旦全てのアクティブクラスを削除
            triggerList.forEach(trigger => {
                trigger.classList.remove('is_active');
            });
            targetList.forEach(target => {
                target.classList.remove('is_active');
            });

            // 該当する番号の要素にアクティブクラス付与
            triggerList[nth].classList.add('is_active');
            targetList[nth].classList.add('is_active');
        }

        // それぞれのトリガー要素にクリックイベントを設定
        for (let i = 0, len = triggerList.length; i < len; ++i) {
            triggerList[i].addEventListener('click', () => {
                changeActive(i); //タブ切り替え
            });
        }
    });
}

export default tab;